// extracted by mini-css-extract-plugin
export var blue = "_2m-f";
export var brand = "_2m-b";
export var darkGrey = "_2m-e";
export var disabled = "_2m-4";
export var disabledSubtle = "_2m-5";
export var error = "_2m-6";
export var green = "_2m-g";
export var grey = "_2m-d";
export var icon = "_2m-0";
export var inherit = "_2m-a";
export var lightGrey = "_2m-c";
export var orange = "_2m-i";
export var pink = "_2m-k";
export var primary = "_2m-1";
export var purple = "_2m-l";
export var red = "_2m-j";
export var secondary = "_2m-2";
export var success = "_2m-9";
export var tertiary = "_2m-3";
export var warning = "_2m-7";
export var warningSecondary = "_2m-8";
export var white = "_2m-m";
export var yellow = "_2m-h";